import { queryClient } from '../main';
import { http } from '../api/http';
import { MatchRoomMetadata } from '@solante/shared';

// Prefetch open matches for instant matchmaking page load
export const prefetchOpenMatches = () => {
  void queryClient.prefetchQuery({
    queryKey: ['matches', 'open'],
    queryFn: () => http.get<{ matches: MatchRoomMetadata[] }>('/matches/open'),
    staleTime: 2_000,
  });
};

// Prefetch active matches for a wallet
export const prefetchActiveMatches = (wallet: string | null | undefined) => {
  if (!wallet) return;
  void queryClient.prefetchQuery({
    queryKey: ['matches', 'active', wallet],
    queryFn: async () => {
      const response = await http.get<{ matches: unknown[] }>(
        `/matches/active?wallet=${encodeURIComponent(wallet)}`,
      );
      return response.matches;
    },
    staleTime: 2_000,
  });
};

// Prefetch leaderboard data
export const prefetchLeaderboard = (type: string = 'elo', limit: number = 100) => {
  void queryClient.prefetchQuery({
    queryKey: ['leaderboard', type, limit],
    queryFn: () => http.get<{ leaderboard: unknown[] }>(`/leaderboard?type=${type}&limit=${limit}`),
    staleTime: 30_000,
  });
};

// Prefetch player stats
export const prefetchPlayerStats = (wallet: string | null | undefined) => {
  if (!wallet) return;
  void queryClient.prefetchQuery({
    queryKey: ['player', 'stats', wallet],
    queryFn: () => http.get<unknown>(`/players/${wallet}/stats`),
    staleTime: 10_000,
  });
};

// Prefetch match history
export const prefetchMatchHistory = (wallet: string | null | undefined) => {
  const search = wallet ? `?wallet=${encodeURIComponent(wallet)}` : '';
  void queryClient.prefetchQuery({
    queryKey: ['matches', 'history', wallet ?? null],
    queryFn: () => http.get<{ history: unknown[] }>(`/matches/history${search}`),
    staleTime: 10_000,
  });
};

// Combined prefetch for matchmaking page
export const prefetchMatchmakingData = (wallet: string | null | undefined) => {
  prefetchOpenMatches();
  prefetchActiveMatches(wallet);
};

// Combined prefetch for leaderboard page
export const prefetchLeaderboardData = () => {
  prefetchLeaderboard('elo');
  prefetchLeaderboard('wins');
  prefetchLeaderboard('earnings');
};
